<template>
    <!-- Header -->
    <div class="header-section">
        <div class="profile-container">
            <img
                src="/logo.png"
                alt="Profile"
                class="profile-image"
            />

            <div class="profile-info">
                <h1 class="profile-name mb-0">
                    {{ $store.state.authUser.name }}
                </h1>

                <p class="profile-phone mb-0">
                    {{ $t('auth.phone') }}:
                    <span>{{ blurLastFiveCharacters($store.state.authUser.phone) }}</span>
                </p>

                <div class="profile-balance">
                    <div class="balance-item">
                        <p class="balance-label">{{ $t("setting.balance") }}</p>
                        <p class="balance-value">
                            {{ Number($store.state.amount).toLocaleString() }} <span>฿</span>
                        </p>
                    </div>

                    <div class="divider"></div>

                    <div class="balance-item">
                        <p class="balance-label">{{ $t("setting.withdraw") }}</p>
                        <p class="balance-value">
                            {{ Number($store.state.totalWithdraw).toLocaleString() }}
                            <span>฿</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        blurLastFiveCharacters(inputString = "0000000000") {
            const length = inputString.length;
            if (length >= 7) {
                const firstPart = inputString.substring(length - 5);
                const blurred = "*".repeat(length - 5);
                return blurred + firstPart;
            }
            return inputString;
        },
    },
};
</script>

<style scoped>
.header-section {
    background: linear-gradient(180deg, #2b1c59 0%, #1b1540 100%);
    padding: 20px 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    display: flex;
    justify-content: center;
}

.profile-container {
    display: flex;
    align-items: center;
    gap: 14px;
    width: 100%;
    max-width: 420px;
}

.profile-image {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    border: 2px solid #ffb800;
    object-fit: cover;
}

.profile-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
    overflow: hidden;
}

.profile-name {
    font-size: 1.1rem;
    font-weight: 600;
    color: #fff;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.profile-phone {
    color: rgba(255, 255, 255, 0.75);
}

.profile-balance {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 10px;
    margin-top: 8px;
    padding: 8px 12px;
}

.balance-item {
    text-align: center;
    flex: 1;
}

.divider {
    width: 1px;
    height: 24px;
    background: rgba(255, 255, 255, 0.15);
    margin: 0 6px;
}

.balance-label {
    color: rgba(255, 255, 255, 0.6);
    margin-bottom: 2px;
}

.balance-value {
    font-weight: 600;
    color: #ffb800;
    margin: 0;
}

.balance-value span {
    opacity: 0.8;
}

@media (max-width: 480px) {
    .header-section {
        padding: 18px 14px;
    }

    .profile-image {
        width: 52px;
        height: 52px;
    }
}
</style>
